import { useState } from 'react';
import { Button, TextArea } from '@navi/web-ui/lib/primitives';
import { ITicketForm } from '../../types';
import CommentTextArea from '../ActivityLog/CommentTextArea';

const TicketForm = (props: ITicketForm) => {
  const { watch, setValue, getValues, register, errors, commentValidation = {} } = props;
  const formValues = getValues('componentAdjustments');

  const [showAddressInput, setShowAddressInput] = useState(false);

  const showAddressInputHandler = () => {
    setShowAddressInput(true);
  };

  const handleCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;
    setValue('componentAdjustments.comment', value);
  };

  const commentValue = watch('componentAdjustments.comment');

  return (
    <div>
      <CommentTextArea
        containerClassName="mt-6"
        {...register(`componentAdjustments.comment`, commentValidation)}
        value={commentValue}
        error={errors?.componentAdjustments?.comment?.message}
        required
        placeholder={`Leave a comment (${
          Object.keys(commentValidation)?.length ? 'mandatory' : 'optional'
        })`}
        onChange={handleCommentChange}
      />
      <div className="mt-4">
        {!showAddressInput ? (
          <Button variant="text" onClick={showAddressInputHandler}>
            + Add new address
          </Button>
        ) : (
          <TextArea
            label="Add new address"
            rows={2}
            containerClassName="w-full"
            placeholder="Enter address"
            {...register(`componentAdjustments.address`)}
            value={formValues?.address}
          />
        )}
      </div>
    </div>
  );
};

export default TicketForm;
